import { render, staticRenderFns } from "./IconPicker.vue?vue&type=template&id=0f27d8b7&scoped=true&"
import script from "./IconPicker.vue?vue&type=script&lang=ts&"
export * from "./IconPicker.vue?vue&type=script&lang=ts&"
import style0 from "./IconPicker.vue?vue&type=style&index=0&id=0f27d8b7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f27d8b7",
  null
  
)

export default component.exports